import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { DaliService } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var OneTimePasswordComponent = /** @class */ (function () {
    function OneTimePasswordComponent(copyService, headerService, formBuilder, abreCuentasService, navigationService, captureService, bioCatchService, validationHelperService, requestService, bitacoraService, parametersService, postvalidate, firmlyApprovedService, channelCommunicatorService, daliService, taggingServices) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.formBuilder = formBuilder;
        this.abreCuentasService = abreCuentasService;
        this.navigationService = navigationService;
        this.captureService = captureService;
        this.bioCatchService = bioCatchService;
        this.validationHelperService = validationHelperService;
        this.requestService = requestService;
        this.bitacoraService = bitacoraService;
        this.parametersService = parametersService;
        this.postvalidate = postvalidate;
        this.firmlyApprovedService = firmlyApprovedService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.daliService = daliService;
        this.taggingServices = taggingServices;
        this.cellphone = '';
        this.products = {
            creditCard: 'tcr',
            payroll: 'cta_nom',
            savings: 'cta',
            revolvingCredit: 'crp',
            freeInvestment: 'ord',
        };
        this.headerService.show(true, true, true);
        this.intentos = this.abreCuentasService.getIntentoOtp();
        this.devicePrint = new LogDeviceModel();
        this.validations = this.abreCuentasService.getValidationOtp();
        this.formGroup = this.formBuilder.group({});
    }
    OneTimePasswordComponent.prototype.ngOnInit = function () {
        this.sendTagging('init');
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendOTPPageLoad();
        }
        this.formGroup = new FormGroup({
            otpFormControl: new FormControl('', [
                Validators.minLength(6),
                Validators.maxLength(6),
                Validators.required,
            ]),
        });
        var nextCode;
        if (this.abreCuentasService.getUserJemelii()) {
            console.log('///** ' + this.abreCuentasService.getContactInfo().mobile_number);
            var contactInfo = this.abreCuentasService.getContactInfo();
            this.phone = contactInfo.mobile_number;
            this.client_id = this.abreCuentasService.getRescueData().number_id + '_1';
            nextCode = '200';
            this.clientDataRequest = true;
            this.clientDataRequestNext = nextCode;
            if (this.phone === '') {
                this.abreCuentasService.caseInfoError('512');
                this.navigationService.nextStep('301');
                return;
            }
        }
        else {
            this.basicData = this.abreCuentasService.getCustomerData().basic;
            if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
                var occupation = this.parametersService.getSetting(OpEnum.OCCUPATIONS_LIST)[0];
                this.abreCuentasService.setOccupationSelected(occupation);
                this.selectedOccupation = occupation;
                var nowDate = new Date();
                var lastUpdateDate = new Date();
                lastUpdateDate.setTime(this.basicData.last_update_date);
                var configClient = this.parametersService.getSetting(OpEnum.CONFIG_CLIENT_EXIST);
                lastUpdateDate.setDate(lastUpdateDate.getDate() + configClient.days_update);
                nextCode = lastUpdateDate.getTime() < nowDate.getTime() ? '106' : '107';
                nextCode = this.getValueOfNextCode(nextCode);
            }
            else {
                nextCode = '200';
            }
            this.clientDataRequest = true;
            this.clientDataRequestNext = nextCode;
            this.client_id = this.basicData.document.number + '_' + this.basicData.document.type;
            this.phone = this.basicData.phones.find(function (x) { return x.phone_type === 'Mobile'; }).phone_number;
            if (this.phone === '') {
                this.abreCuentasService.caseInfoError('512');
                this.navigationService.nextStep('301');
                return;
            }
        }
        this.generateCode();
    };
    OneTimePasswordComponent.prototype.getValueOfNextCode = function (nextCode) {
        return ((!this.validationHelperService.isValidExistingClient() ||
            this.abreCuentasService.getOccupationSelected().name !== this.basicData.profession) &&
            this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) ? '106' : nextCode;
    };
    OneTimePasswordComponent.prototype.validateOtpCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var device, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendTagging('next', 'bottom', '2');
                        if (this.taggingServices.isFirmlyAprovedMono()) {
                            this.sendValidateButtonEvent();
                        }
                        this.validations++;
                        this.abreCuentasService.setIntentoOtp(this.validations);
                        if (this.blockOtp(this.validations, 4) || this.blockOtp(this.intentos)) {
                            return [2 /*return*/];
                        }
                        device = this.abreCuentasService.getDeviceInfo();
                        body = {
                            data: {
                                client_id: this.client_id,
                                authorization_code: this.numberCode,
                                divice_print: device.device_id,
                                device_cookie: '',
                            },
                        };
                        return [4 /*yield*/, this.captureService.validateOTP(body).then(function (res) {
                                try {
                                    if (res.body) {
                                        _this.next();
                                    }
                                    else if (res.code) {
                                        var code = res.code;
                                        code = String(code).split('|')[2];
                                        switch (code) {
                                            case '3':
                                                _this.alertModel = { message: 'El código que ingresaste es incorrecto.', type: 'error', icon: '' };
                                                break;
                                            case '6':
                                            case '10':
                                                _this.alertModel = { message: 'El código de confirmación ha expirado. Reenvia el código.', type: 'error', icon: '' };
                                                break;
                                            default:
                                                _this.navigationService.navigateToGeneralInformation('500');
                                        }
                                    }
                                    else {
                                        _this.navigationService.navigateToGeneralInformation('500');
                                    }
                                }
                                catch (e) {
                                    console.log(e);
                                }
                            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OneTimePasswordComponent.prototype.reactiveInputChangeCode = function (e) {
        var value = String(e.item.value);
        value = value.replace(/\D/g, '');
        e.$event.target.value = value;
        this.numberCode = value;
        /* this.otpFormControl.setValue(value); */
        var controlIncomes = this.formGroup.controls['otpFormControl'];
        controlIncomes.setValue(value);
    };
    OneTimePasswordComponent.prototype.resendConfirmationCode = function () {
        this.sendTagging('resend', 'bottom', '3');
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendResendOTPButtonEvent();
        }
        try {
            this.intentos++;
            this.abreCuentasService.setIntentoOtp(this.intentos);
            if (this.blockOtp(this.intentos)) {
                return;
            }
            var selectedProduct = this.abreCuentasService.getproductSelected();
            var eventName = 'resend_otp_' + this.products[selectedProduct.product_type];
            this.sendBitacora(eventName);
        }
        catch (error) {
            console.log();
        }
        this.generateCode(true);
    };
    OneTimePasswordComponent.prototype.gotoProblems = function () {
        this.sendTagging('problems', 'bottom', '4');
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendHaveProblemsButtonEvent();
        }
        this.navigationService.nextStep('301');
    };
    OneTimePasswordComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedProduct, event_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedProduct = this.abreCuentasService.getproductSelected();
                        try {
                            event_1 = 'identification_otp_' + this.products[selectedProduct.product_type];
                            this.sendBitacora(event_1);
                        }
                        catch (error) {
                            console.log();
                        }
                        if (!(selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL)) return [3 /*break*/, 3];
                        this.postvalidate.solicitationId();
                        if (!this.firmlyApprovedService.isEmpty()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.callIncomes()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        this.incomesRequest = true;
                        this.incomesRequestNext = '000';
                        _a.label = 4;
                    case 4:
                        this.advance();
                        return [2 /*return*/];
                }
            });
        });
    };
    OneTimePasswordComponent.prototype.generateCode = function (showAlert) {
        if (showAlert === void 0) { showAlert = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var device, contact, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        device = this.abreCuentasService.getDeviceInfo();
                        contact = this.abreCuentasService.getUserJemelii() ? this.abreCuentasService.getContactInfo()
                            : this.abreCuentasService.getCustomerData().contact;
                        body = {
                            data: {
                                client_id: this.client_id,
                                email: contact.email,
                                phone: {
                                    phone_number: this.phone,
                                },
                                divice_print: device.device_id,
                                device_cookie: '',
                                trn_code: '5',
                            },
                        };
                        return [4 /*yield*/, this.captureService.getOTP(body).then(function (res) {
                                try {
                                    if (res.data.message === 'procesado.') {
                                        if (!showAlert) {
                                            return;
                                        }
                                        _this.alertModel = { message: 'Código reenviado', type: 'success', icon: 'check' };
                                    }
                                    else if (res.data) {
                                        var code = res.data.mensagem.code;
                                        code = String(code).split('|')[2];
                                        if (code === '1010016') {
                                            _this.alertModel = { message: 'Has llegado al número de intentos permitidos, intenta mañana.', type: 'error', icon: '' };
                                            _this.navigationService.pageLoadTag('alertModel', ['pv428', '', '', '']);
                                        }
                                        else {
                                            _this.navigationService.navigateToGeneralInformation('500');
                                        }
                                    }
                                }
                                catch (e) {
                                    console.log(e);
                                }
                            }).catch(function (error) { return console.log(error); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OneTimePasswordComponent.prototype.callIncomes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.sendProspectOccupation().then(function (res) {
                            console.log('callIncomes >>> Linea 255 >>> ', res);
                            var nextCode = '';
                            if (res) {
                                _this.abreCuentasService.setinfoInferredIncomes(res.body.data);
                                if (!res.status || res.status === 500) {
                                    nextCode = '500';
                                }
                                else if (res.status !== 200) {
                                    var codigo = res.body.data.codigo;
                                    switch (codigo) {
                                        case '422-06':
                                            nextCode = '106';
                                            break;
                                        case '422-07':
                                            nextCode = '106';
                                            break;
                                        case '400':
                                            nextCode = '500';
                                            break;
                                    }
                                }
                                else if (res.body.data.income_amount.amount === 0) {
                                    nextCode = '106';
                                }
                                else {
                                    nextCode = '000';
                                }
                            }
                            else {
                                nextCode = '500';
                            }
                            _this.incomesRequest = true;
                            _this.incomesRequestNext = nextCode;
                        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OneTimePasswordComponent.prototype.blockOtp = function (intentos, validate) {
        if (validate === void 0) { validate = 4; }
        var flag = intentos >= validate;
        if (flag) {
            if (intentos > validate) {
                this.navigationService.nextStep('201');
            }
            this.alertModel = { message: 'Has llegado al número de intentos permitidos, intenta mañana.', type: 'error', icon: '' };
        }
        return flag;
    };
    OneTimePasswordComponent.prototype.sendBitacora = function (eventName) {
        this.bitacoraService.saveDataInBitacora(eventName);
    };
    OneTimePasswordComponent.prototype.advance = function () {
        console.log('One-Time >>>>> ClientDataRequest >>> ', this.clientDataRequest, '\n IncomesRequest >>>> ', this.incomesRequest);
        if (this.clientDataRequest && this.incomesRequest) {
            if (this.abreCuentasService.getUserJemelii()) {
                this.navigationService.nextStep('200');
            }
            else if (!this.validationHelperService.validateMailPhone() &&
                this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
                this.navigationService.navigateToGeneralInformation('512');
            }
            else if (this.incomesRequestNext === '000') {
                this.navigationService.nextStep(this.clientDataRequestNext);
            }
            else {
                this.navigationService.navigateToGeneralInformation(this.incomesRequestNext);
            }
        }
        else if (this.abreCuentasService.getproductSelected().product_type === 'creditCard' && this.clientDataRequest) {
            this.navigationService.nextStep(this.clientDataRequestNext);
        }
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    OneTimePasswordComponent.prototype.sendOTPPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA.pv2pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv2pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv2pageFamily.path,
                value: PAGEVIEW_FA.pv2pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv2subFamily.path,
                value: PAGEVIEW_FA.pv2subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv2pageAction.path,
                value: PAGEVIEW_FA.pv2pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv2pageid.path,
                value: OneTimePasswordComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv2transactionName.path,
                value: "" + PAGEVIEW_FA.pv2transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv2transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv2transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* ------------ Taggeo - Events ------------ */
    OneTimePasswordComponent.prototype.sendBackButtonEvent = function () {
        this.sendTagging('prev', 'top', '1');
        if (!this.taggingServices.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_LD.pv2E1setData.pv2E1transactionTransactionStep.path,
                value: EVENT_FA_LD.pv2E1setData.pv2E1transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv2E1setData.pv2E1transactionName.path,
                value: "" + EVENT_FA_LD.pv2E1setData.pv2E1transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.bottom,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv2E1customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    OneTimePasswordComponent.prototype.sendValidateButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_LD.pv2E2setData.pv2E2transactionTransactionStep.path,
                value: EVENT_FA_LD.pv2E2setData.pv2E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv2E2setData.pv2E2transactionName.path,
                value: "" + EVENT_FA_LD.pv2E2setData.pv2E2transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.bottom,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv2E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    OneTimePasswordComponent.prototype.sendResendOTPButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_LD.pv2E3setData.pv2E3transactionTransactionStep.path,
                value: EVENT_FA_LD.pv2E3setData.pv2E3transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv2E3setData.pv2E3transactionName.path,
                value: "" + EVENT_FA_LD.pv2E3setData.pv2E3transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.bottom,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv2E3customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    OneTimePasswordComponent.prototype.sendHaveProblemsButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_LD.pv2E4setData.pv2E4transactionTransactionStep.path,
                value: EVENT_FA_LD.pv2E4setData.pv2E4transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv2E4setData.pv2E4transactionName.path,
                value: "" + EVENT_FA_LD.pv2E4setData.pv2E4transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.bottom,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv2E4customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    OneTimePasswordComponent.prototype.sendTagging = function (value, position, event) {
        var page = '3';
        var extras = {
            pageValue: 'OneTimePassword',
        };
        this.taggingServices.sendTaggValues(value, page, position, event, extras);
    };
    return OneTimePasswordComponent;
}());
export { OneTimePasswordComponent };
